import { defineMessages } from 'react-intl';

export default defineMessages({
  myServices: {
    id: 'dashboard_asi.my_services',
  },
  contactAgent: {
    id: 'dashboard_asi.contact_agent',
  },
  partnerClinic: {
    id: 'dashboard_asi.partner_clinic',
  },
});
